import angular from 'angular';
import common from './core.module';
import AccountNotificationsController from './controllers/account/notifications.controller';
import AccountPasswordController from './controllers/account/password.controller';
import AccountPersonalController from './controllers/account/personal.controller';

const moduleName = 'atc-account';
angular.module(moduleName, [common])
    .controller('AccountNotificationsController', AccountNotificationsController)
    .controller('AccountPasswordController', AccountPasswordController)
    .controller('AccountPersonalController', AccountPersonalController)
;



export default moduleName;